import type { Ticket } from '../api/types';

// Gründe für „Kein Objekt“ bei einem verpassten Anruf unbekannter Nummer.
export const noObjectReasons = ['Käufer/Interessent', 'Makler oder Werbung', 'Falsch verbunden', 'Nicht erreicht, keine Nachricht', 'Sonstiges'];

// isMissedUnknownCall: offene Rückfrage zu einem verpassten Anruf, der noch keinem Objekt zugeordnet ist.
export function isMissedUnknownCall(t: Pick<Ticket, 'call_id' | 'lead_id' | 'status' | 'subject'>): boolean {
  return !!t.call_id && !t.lead_id && ['OPEN', 'IN_PROGRESS', 'WAITING'].includes(t.status) && t.subject.startsWith('Verpasster Anruf von');
}
